<template>
<div class="chapter">
<div class="inner_page">
<p class="toc-head">Contents</p>
<p class="toc-part" id="part-1"><a href="#/Brownsville_part1">I Thought You and Me Were Friends</a></p>
<p class="toc-chapter" id="chap-1"><a href="#/Brownsville_chap1">Mr. Z</a></p>
<p class="toc-chapter" id="chap-2"><a href="#/Brownsville_chap2">RG</a></p>
<p class="toc-chapter" id="chap-3"><a href="#/Brownsville_chap3">Chango</a></p>
<p class="toc-part" id="part-2"><a href="#/Brownsville_part2">They Say He Was Lost</a></p>
<p class="toc-chapter" id="chap-4"><a href="#/Brownsville_chap4">Domingo</a></p>
<p class="toc-chapter" id="chap-5"><a href="#/Brownsville_chap5">Big Jesse, Little Jesse</a></p>
<p class="toc-chapter" id="chap-6"><a href="#/Brownsville_chap6">Charro</a></p>
<p class="toc-part" id="part-3"><a href="#/Brownsville_part3">Don't Believe Anything He Tells You</a></p>
<p class="toc-chapter" id="chap-7"><a href="#/Brownsville_chap7">Jerry Fuentes</a></p>
<p class="toc-chapter" id="chap-8"><a href="#/Brownsville_chap8">Yolanda</a></p>
<p class="toc-chapter" id="chap-9"><a href="#/Brownsville_chap9">Mrs. Perez</a></p>
<p class="toc-part" id="ackn-1"><a href="#/Brownsville_ackn1">Acknowledgments</a></p>
<p class="toc-part" id="afte-1"><a href="#/Brownsville_afte1">A Note on the Type</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Brownsville_toc.vue?48f9290c